import styled from 'styled-components';

export const Container = styled.div``;

export const Item = styled.div`
  display: flex;
  margin-bottom: 24px;
  color: #202020;
  font-size: 14px;
  font-weight: 500;
  align-items: center;
  height: 31px;

  & > p {
    width: 80px;
    height: 24px;
  }

  & > :nth-child(2) {
    width: 372px;
  }
`;
